'use client'

import { createContext, useContext } from 'react'

import { SaleOrder } from '../../../types'

export interface EditSaleOrderModalsContextType {
  cancelEditOpen: boolean
  handleCancelEditOrder: () => void
  handleCloseCancelEditModal: () => void
  handleCloseSubmitEditModal: () => void
  handleSubmitEditOrder: () => void
  submitEditOpen: boolean
  startOrder: SaleOrder | null
  setOrderDataFromLocalStorage: () => void
  clearStates: () => void
}

export const EditSaleOrderModalsContext = createContext<
  EditSaleOrderModalsContextType | undefined
>(undefined)

export const useEditSaleOrderModals = () => {
  const context = useContext(EditSaleOrderModalsContext)

  if (!context) {
    throw new Error(
      'useEditSaleOrderModals must be used within an EditSaleOrderModalsProvider'
    )
  }

  return context
}
